import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import CookieConsent, { getCookieConsentValue } from 'react-cookie-consent';
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';
import TagManager from 'react-gtm-module';
import './App.css';
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { Links } from "./components/Links";
import { InputForm, InputFormState } from "./components/Form";
import ScrollToTop from "./components/ScrollToTop";
import {Subscribe} from "./components/Subscribe";

class App extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      answer: null,
      showResult: false
    }
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(e: InputFormState) {
    this.setState({
      answer: e.answer,
      showResult: true
    });
    //console.log(e)
  }

  render() {
    const answer = this.state.answer;
    const showResult = this.state.showResult;

    //let content = showResult ? <Result answer={answer} /> : <InputForm onSubmit={this.handleSubmit} />;

    const track = () => {
      /*ReactGA.initialize('');
      ReactGA.pageview(window.location.pathname + window.location.search);*/
      ReactPixel.init('');
      ReactPixel.pageView();
      TagManager.initialize({ gtmId: '' }); // Kolla rätt tagmanager GTM-KQ6HZWS
    }

    const handleAcceptCookie = () => {
      track();
    }

    if (getCookieConsentValue()) {
      track();
    }

    return (
      <Router>

        <div className="form">
          <Switch>
            {
            <Route path="/darfor">
              <ScrollToTop/>
              <Links/>
            </Route>
            }
            <Route path="/">
              <Header/>
              <div className="subsribeform">
                <Subscribe/>
              </div>
            </Route>
          </Switch>

        </div>
        <Footer/>
        <CookieConsent buttonText="Jag godkänner"
                       declineButtonText="jag godkänner inte"
                       enableDeclineButton
                       onAccept={handleAcceptCookie}
                       buttonClasses="cookiebtn"
                       disableButtonStyles={true}
                       containerClasses="cookiecontainer"
                       style={{alignItems: "center"}}
                       contentClasses="cookiecontent">
          <h6>Denna webbplats använder cookies</h6>
          <p>Vi och tredjeparterna Facebook och Google placerar ut cookies på webbplatsen för att samla statistik om hur webbplatsen används och för marknadsföringsändamål om du lämnar ditt godkännande till sådan användning av cookies.</p>
          <p>Du kan läsa mer om cookies i vår cookiepolicy och om hur vi behandlar personuppgifter i samband med användning av cookies i vår <a href="https://moderaterna.se/gdpr" target="_blank" rel="noreferrer">integritetspolicyn</a> innan du gör dina val.</p>
        </CookieConsent>
      </Router>
    );
  }
}

export default App;
